/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentViewQueryOwner extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AssessmentViewQueryOwner");
    }

    getFixupPrototypeFunction() { return AssessmentViewQueryOwner.fixupPrototype; }

    static newInstance(model: Partial<AssessmentViewQueryOwner>): AssessmentViewQueryOwner {
        let obj = Object.assign(new AssessmentViewQueryOwner(), model);
        AssessmentViewQueryOwner.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentViewQueryOwner>): AssessmentViewQueryOwner {
        if (!model) return null;
        return AssessmentViewQueryOwner.newInstance(<AssessmentViewQueryOwner> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentViewQueryOwner) {
        if (!obj) return;

        models.AssessmentViewQueryOwner.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentViewQueryOwner): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AssessmentViewQueryOwner.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Owner of question
     */
    owners: Array<string>;

}
